import {ServiceClass} from '@/decorators';
import {CableModel, CreateEditCableViewModel, UpdateCableSortOrderModel} from '../models';
import {BaseApi} from './base.api';

@ServiceClass()
export class CablesApi extends BaseApi {
    public getLocationCables(locationId: string, filter: any = {}) {
        return this.GET_RequestAsync<CableModel[]>(
            `${this.ApiUrl}/location-connections/${locationId}/cables?filter=${encodeURIComponent(JSON.stringify(filter))}`
        );
    }

    public getCableById(id: string) {
        return this.GET_RequestAsync<CableModel>(`${this.ApiUrl}/location-connections/cables/${id}`);
    }

    public createCable(locationId: string, data: CreateEditCableViewModel) {
        return this.POST_RequestAsync<CableModel>(`${this.ApiUrl}/location-connections/${locationId}/cables`, data);
    }

    public createCablesMultiple(locationId: string, afterOrder: number, data: CreateEditCableViewModel[]) {
        return this.POST_RequestAsync<CableModel[]>(`${this.ApiUrl}/location-connections/${locationId}/cables/multiple?afterOrder=${afterOrder}`, data);
    }

    public updateCable(locationId: string, cableId: string, data: CreateEditCableViewModel) {
        delete data.id;
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/location-connections/${locationId}/cables/${cableId}`, data);
    }

    public markCableActive(cableId: string) {
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/cables/${cableId}/mark-active`, {});
    }

    public markCableInactive(cableId: string) {
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/cables/${cableId}/mark-inactive`, {});
    }

    public deleteCableAsync(id: string) {
        return this.DELETE_RequestAsync<void>(`${this.ApiUrl}/cables/${id}`);
    }

    public updateSortOrder(locationId: string, data: UpdateCableSortOrderModel) {
        return this.POST_RequestAsync<void>(`${this.ApiUrl}/location-connections/${locationId}/cables/sort-order`, data);
    }
}
